import { Component, OnInit, Input } from '@angular/core';


@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
    constructor() {}

    @Input() message: string;

    @Input() data: string;

    ngOnInit(): void {}
}
